import { Formik, Form } from 'formik'
import React, { useContext, useState } from 'react'
import AppNavigation from '../../AppNavigation'
import ResinousCoverageDetailsModals from './ResinousCoverageDetailsModals'
import { CustomInputTotalArea, CustomToggle, CustomSelect, CustomChipAndColorFields } from './resinousFormInputs'
import { AppContext } from '../../../App'
import * as Yup from 'yup'
import axios from 'axios'
import config from '../../../config.json'

export default function ResinousCoverageDetails() {
   const {
      setAppHeader,
      setCurrentStep,
      stepsCompleted,
      setStepsCompleted,
      setCoverageDetails,
      productOptionsSelected,
      resinousTractionAdditives,
      setCalculatedProducts,
      availableColors,
      availableLargeColors,
       availableSmallColors,
       availableLargeVaporBanColors,
       availableSmallVaporBanColors,
       availableLargeVaporBanChipColors,
       availableSmallVaporBanChipColors,
       availableLargeMvbColors,
       availableSmallMvbColors,
       availableLargeMvbChipColors,
       availableSmallMvbChipColors,
       availableLargeChipColors,
       availableSmallChipColors,
       availableLargeQuartzColors,
       availableSmallQuartzColors,
       availableChipColors,
       availableQuartzColors,
      setSelectedChip,
      setSelectedColor,
       setAvailableColors,
       setAvailableChipColors,
       setAvailableQuartzColors,
      vaporBarriers,
      unit,
      setUnit,
      toastNotify,
      setApiError,
      chipValue,
      setChipValue,
      colorValue,
      setColorValue,
      colorImage,
       setColorImage,
       bu,
       iso,
       setColorSku,
       setColorChipSku,
       setColorCoverage,
       setColorChipCoverage,
       setColorChipUnitsRequired,
      chipImage,
      setChipImage
   } = useContext(AppContext)

   const [stateTotalArea, setStateTotalArea] = useState()
   const [stateVaporBarrier, setStateVaporBarrier] = useState()
   const [stateSubstratePreparation, setStateSubstratePreparation] = useState()
   const [stateExtraTopCoat, setStateExtraTopCoat] = useState(false)
   const [stateClinicalPlus, setStateClinicalPlus] = useState(false)
   const [stateTractionAdditive, setStateTractionAdditive] = useState()
   const [statePreferredPackagingSize, setStatePreferredPackagingSize] = useState()
   const [stateColorValue, setStateColorValue] = useState()
    const [stateChipValue, setStateChipValue] = useState()

   // Get substrate preparation configuration data for each resinous system type.
   const { hb, ptc, pure, sb, utc, xpl, hasVaporBarrier, vaporBanAndMVB } = config.resinousSystemVaporBarrierRules
    const systemTypeName = productOptionsSelected.productOptions[4].toLowerCase()
    const systemName = productOptionsSelected.productOptions[3].toLowerCase()

    //set extra top coar label to be different for urethane systems
    let topCoatLabel = "Extra Top Coat?"
    console.log(systemName)
    if (systemName == "spartacote urethane cement sl" || systemName == "spartacote urethane cement ats") {
        topCoatLabel = "Extra Urethane Cement Top Coat?"
    }

   const handlePreferredPackagingSizeChange = value => {
      // Reset color and chip selectors to initial blank state
      setStateChipValue()
      setStateColorValue()
      setChipImage()
      setColorImage()
      // If value does not equal "Select", set value in state. Else reset state.
      if(value!=="Select") {
         setStatePreferredPackagingSize(value)
      } else {
         setStatePreferredPackagingSize()
      }

      // If vapor barrier is set do not change the available colors, as vaporbarrier colors override all other colors always.
      // If vapor barrier is not set, set the available colors to standard small or large colors.
       if (!stateVaporBarrier || stateVaporBarrier === "None" || stateVaporBarrier === "Select" || systemName === "spartacote metallic") {
           setAvailableColors(
               value === "Small" ? (
                   availableSmallColors
               ) : (
                   availableLargeColors
               )
           )
           setAvailableChipColors(
               value === "Small" ? (
                   availableSmallChipColors
               ) : (
                   availableLargeChipColors
               )
           )
           setAvailableQuartzColors(
               value === "Small" ? (
                   availableSmallQuartzColors
               ) : (
                       availableLargeQuartzColors
                   )
           )
       } else {
           if (stateVaporBarrier === "Spartacote MVB") {
               // Vapor barrier is set. MVB
               setAvailableColors(
                   value === "Small" ? (
                       availableSmallMvbColors
                   ) : (
                           availableLargeMvbColors
                       )
               )
               setAvailableChipColors(
                   value === "Small" ? (
                       availableSmallMvbChipColors
                   ) : (
                           availableLargeMvbChipColors
                       )
               )
           } else {
               // Vapor barrier is set. VB
               setAvailableColors(
                   value === "Small" ? (
                       availableSmallVaporBanColors
                   ) : (
                           availableLargeVaporBanColors
                       )
               )
               setAvailableChipColors(
                   value === "Small" ? (
                       availableSmallVaporBanChipColors
                   ) : (
                           availableLargeVaporBanChipColors
                       )
               )
           }
       }
   }

    

   const handleVaporBarrierChange = value => {
      // Reset color and chip selectors to initial blank state
      setStateChipValue()
      setStateColorValue()
      setChipImage()
      setColorImage()
      // If substrate prep is set and vapor barrier value is not set (or "None"), reset substrate prep state and vapor barrier state
      if (stateSubstratePreparation && (!value || value==="None")) {
         setStateSubstratePreparation('')
         setStateVaporBarrier('')
      } else {
         // Else set the vapor barrier state
         setStateVaporBarrier(value)
      }
       
      // Set colors
       if (!value || value === "None" || value === "Select" || systemName === "spartacote metallic") {
         // Vapor barrier is not set, available colors are availableSmallColors and availableLargeColors if preferred packaging size is already set
         statePreferredPackagingSize && (
               setAvailableColors(
                  statePreferredPackagingSize==="Small" ? (
                     availableSmallColors
                  ) : (
                           availableLargeColors                         
                  )
               )
         )
       } else {
           if (value === "Spartacote MVB") {
               statePreferredPackagingSize && (
                   setAvailableColors(
                       statePreferredPackagingSize === "Small" ? (
                           availableSmallMvbColors
                       ) : (
                               availableLargeMvbColors
                           )
                   )
               )
               statePreferredPackagingSize && (
                   setAvailableChipColors(
                       statePreferredPackagingSize === "Small" ? (
                           availableSmallMvbChipColors
                       ) : (
                               availableLargeMvbChipColors
                           )
                   )
               )
           } else {
               // Vapor barrier is set. VB
               statePreferredPackagingSize && (
                   setAvailableColors(
                       statePreferredPackagingSize === "Small" ? (
                           availableSmallVaporBanColors
                       ) : (
                               availableLargeVaporBanColors
                           )
                   )
               )
               statePreferredPackagingSize && (
                   setAvailableChipColors(
                       statePreferredPackagingSize === "Small" ? (
                           availableSmallVaporBanChipColors
                       ) : (
                               availableLargeVaporBanChipColors
                           )
                   )
               )
           }
       }
   }

   const handleExtraTopCoatChange = () => {
      stateExtraTopCoat ? (
         setStateExtraTopCoat(false)
      ) : (
         setStateExtraTopCoat(true)
      )
   }
   const handleClinicalPlusChange = () => {
      stateClinicalPlus ? (
         setStateClinicalPlus(false)
      ) : (
         setStateClinicalPlus(true)
      )
   }


   // HANDLE FORM SUBMISSION
   const handleFormSubmission = (formData) => {

      // Add the input data to state of App.
      setCoverageDetails({ formData })

      // Capture form data.
      const {
         clinicalPlus,
         extraTopCoat,
         totalArea,
         vaporBarrier
      } = formData
      
      function fetchCalculation(callback) {

         // Prepare the API URL depending on form data.
         const apiUrlRoot = config.resinousMainCalculationEndpoint
         const systemTypeName = productOptionsSelected.productOptions[4].toLowerCase()
         const subCategory = "floor"
         const addOnVaporBan = vaporBarrier.toLowerCase().indexOf('vapor ban') > -1 ? "yes" : "no"
         const addOnClinicalPlus = clinicalPlus ? "yes" : "no"
         const addOnExtraTopCoat = extraTopCoat ? "yes" : "no"
         const addOnMvb = vaporBarrier.toLowerCase().indexOf('spartacote mvb') > -1 ? "yes" : "no"
          const apiCompleteUrl = apiUrlRoot + "/" + unit + "/" + systemTypeName + "/" + subCategory + "/" + addOnVaporBan + "/" + addOnMvb + "/" + addOnClinicalPlus + "/" + addOnExtraTopCoat + "/" + bu + "/" + iso + "/" + totalArea + "/" + stateSubstratePreparation

         // Fetch the calculated products and information for the quote based on the URL parameters.
         axios.get(apiCompleteUrl)
         .then(res => {
            // Set the response data in state on <App> for retrieval on quote screen.
            setCalculatedProducts(res.data)
            const message = "Success! Quote created."
            const type = "success"
            toastNotify(message, type)
         })
         .catch(error => {
            console.log(error)
            setApiError(error)
            const message = "Something went wrong and the quote could not be created."
            const type = "error"
            toastNotify(message, type)
         })
         // Update the current step.
         callback(({ step: "resinousQuoteCreated" }))
      }

      // Update the steps completed to include this step.
      stepsCompleted.push("Provide Coverage Details")
      setStepsCompleted(stepsCompleted)
      // Set the appHeader for Step state.
      setAppHeader("Quote created.")
      // Set the selected chip and color.
      setSelectedChip(chipValue)
       setSelectedColor(colorValue)
      // Send user selections to API for calculation then use callback for setcurrentStep.
      fetchCalculation(setCurrentStep)
   }
   // END HANDLE FORM SUBMISSION

   // Determine which substrate preps are available, dependent on if and which system type has been selected.
   const substratePreparationsAvailable = (
      // If vapor barrier is set, and not "None", substrate preps available are no longer dependent on system type selected—they are immutable and cannot be changed.
      (stateVaporBarrier && stateVaporBarrier!=="None") ? hasVaporBarrier : (
         systemTypeName.toLowerCase().indexOf('hb') > -1 ? hb : (
               systemTypeName.toLowerCase().indexOf('ptc') > -1 ? ptc : (
                  systemTypeName.toLowerCase().indexOf('pure') > -1 ? pure : (
                     systemTypeName.toLowerCase().indexOf('sb') > -1 ? sb : (
                           systemTypeName.toLowerCase().indexOf('utc') > -1 ? utc : (
                              systemTypeName.toLowerCase().indexOf('xpl') > -1 ? xpl : (
                                 (systemTypeName.toLowerCase().indexOf('vapor ban') > -1 || systemTypeName.toLowerCase().indexOf('vapor barrier') > -1) ? vaporBanAndMVB : (
                                    hasVaporBarrier
                                 )
                              )
                           )
                     )
                  )
               )
         )
      )
   )

   // Determine appropriate validation schema based on which system type is selected.
   const validationSchemaBasedOnSystemType = (
      // If 'chip' or 'quartz', but not 'urethane cement'
      ((systemTypeName.indexOf('chip') > -1 || systemTypeName.indexOf('quartz') > -1) && systemTypeName.indexOf('urethane')===-1) ? (
         Yup.object().shape({
            totalArea: Yup.number()
               .required('This field is required.')
               .positive('This value must be positive.'),
            unit: Yup.string()
               .required('Select ft&#178; or m&#178;'),
            vaporBarrier: Yup.string()
               .required('This field is required.')
               .oneOf(['None', ...vaporBarriers.map(vb => vb.value)]),
            substratePreparation: Yup.string()
               .required('This field is required.')
               .oneOf(substratePreparationsAvailable.map(sp => sp)),
            preferredPackagingSize: Yup.string()
               .oneOf(['Small','Large'])
               .required('This field is required.'),
            chipSelection: Yup.string()
               .required('This field is required.'),
            colorSelection: Yup.string()
               .oneOf(availableColors.map(color => color.Name))
               .required('This field is required.'),      
            tractionAdditive: Yup.string()
               .required('This field is required.')
         })
      ) : (
         // If 'guard' or 'metallic'
         (systemTypeName.indexOf('guard') > -1 || systemTypeName.indexOf('metallic') > -1) ? (
            Yup.object().shape({
               totalArea: Yup.number()
                  .required('This field is required.')
                  .positive('This value must be positive.'),
               unit: Yup.string()
                  .required('Select ft&#178; or m&#178;'),
               vaporBarrier: Yup.string()
                  .required('This field is required.')
                  .oneOf(['None', ...vaporBarriers.map(vb => vb.value)]),
               substratePreparation: Yup.string()
                  .required('This field is required.')
                  .oneOf(substratePreparationsAvailable.map(sp => sp)),
               preferredPackagingSize: Yup.string()
                  .oneOf(['Small','Large'])
                  .required('This field is required.'),
               colorSelection: Yup.string()
                  .oneOf(availableColors.map(chip => chip.Name))
                  .required('This field is required.'),      
               tractionAdditive: Yup.string()
                  .required('This field is required.')
            })
         ) : (
            // If 'seal'
            systemTypeName.indexOf('seal') > -1 ? (
               Yup.object().shape({
                  totalArea: Yup.number()
                     .required('This field is required.')
                     .positive('This value must be positive.'),
                  unit: Yup.string()
                     .required('Select ft&#178; or m&#178;'),
                  vaporBarrier: Yup.string()
                     .required('This field is required.')
                     .oneOf(['None', ...vaporBarriers.map(vb => vb.value)]),
                  substratePreparation: Yup.string()
                     .required('This field is required.')
                     .oneOf(substratePreparationsAvailable.map(sp => sp)),
                  preferredPackagingSize: Yup.string()
                     .oneOf(['Small','Large'])
                     .required('This field is required.'),    
                  tractionAdditive: Yup.string()
                     .required('This field is required.')
               })
               ) : (
                  // If 'moisture mitigation'
                  systemTypeName.indexOf('moisture') > -1 ? ( 
                     Yup.object().shape({
                        totalArea: Yup.number()
                           .required('This field is required.')
                           .positive('This value must be positive.'),
                        unit: Yup.string()
                           .required('Select ft&#178; or m&#178;'),
                        substratePreparation: Yup.string()
                           .required('This field is required.')
                           .oneOf(substratePreparationsAvailable.map(sp => sp)),
                        preferredPackagingSize: Yup.string()
                           .oneOf(['Small','Large'])
                           .required('This field is required.')
                     })
                  ) : (
                     // If 'urethane cement'
                     systemTypeName.indexOf('urethane') > 1 && (
                        // If includes chip/quartz
                        systemTypeName.indexOf('chip') > -1 || systemTypeName.indexOf('chip') > -1 ? (
                           Yup.object().shape({
                              totalArea: Yup.number()
                                 .required('This field is required.')
                                 .positive('This value must be positive.'),
                              unit: Yup.string()
                                 .required('Select ft&#178; or m&#178;'),
                              substratePreparation: Yup.string()
                                 .required('This field is required.')
                                 .oneOf(substratePreparationsAvailable.map(sp => sp)),
                              preferredPackagingSize: Yup.string()
                                 .oneOf(['Small','Large'])
                                 .required('This field is required.'),
                              chipSelection: Yup.string()
                                 .oneOf(availableChipColors.map(chip => chip.Name))
                                 .required('This field is required.'),
                              colorSelection: Yup.string()
                                 .oneOf(availableColors.map(color => color.Name))
                                 .required('This field is required.'),      
                              tractionAdditive: Yup.string()
                                 .required('This field is required.')
                           })
                        ) : (
                           // Else not chip/quartz
                           Yup.object().shape({
                              totalArea: Yup.number()
                                 .required('This field is required.')
                                 .positive('This value must be positive.'),
                              unit: Yup.string()
                                 .required('Select ft&#178; or m&#178;'),
                              substratePreparation: Yup.string()
                                 .required('This field is required.')
                                 .oneOf(substratePreparationsAvailable.map(sp => sp)),
                              preferredPackagingSize: Yup.string()
                                 .oneOf(['Small','Large'])
                                 .required('This field is required.'),
                              colorSelection: Yup.string()
                                 .oneOf(availableColors.map(color => color.Name))
                                 .required('This field is required.'),      
                              tractionAdditive: Yup.string()
                                 .required('This field is required.')
                           })
                        )
                     )
                  )
               )
            )
         )
      )
   

   const formProps = isSubmitting => (
      <Form>
         <CustomInputTotalArea
            label="Total Area"
            name="totalArea"
            id="totalArea"
            type="number"
            placeholder="Enter total area"
            unit={ unit }
            setUnit={ setUnit }
            onBlur={ (e) => setStateTotalArea(e.target.value) }
         />
         {  
         // If 'moisture mitigation' or 'urethane cement', don't include vapor barrier field (it's redundant).
         (systemTypeName.indexOf('moisture')===-1 && systemTypeName.indexOf('vapor')===-1 && systemTypeName.indexOf('urethane')===-1) && 
         <CustomSelect
            label="Select Vapor Barrier"
            name="vaporBarrier"
            onChange={ 
               // If substrate preparation has been set, and vapor barrier selected is '', set stateSubstratePreparation and setStateVaporBarrier to '', which resets them to initial values.
               (e) => handleVaporBarrierChange(e.target.value)
            }
         >
         {   
            // If vapor barrier has not yet been set, render "Select".
            !stateVaporBarrier && <option value="Select">Select</option>
         }
            { // If moisture mitigation, "None" is not a valid option, so don't include it.
            systemTypeName.indexOf('moisture')===-1 && <option key={ 'None' } value={ 'None' }>None</option> }
            {
               // Create an option for each available vapor barrier.
               vaporBarriers.map(vb => {
                  return (
                     <option key={ vb.value } value={ vb.value }>{ vb.text }</option>
                  )
               })
            }
         </CustomSelect>
         }
         <CustomSelect
            label="Substrate Preparation"
            name="substratePreparation"
            onChange={ (e) => setStateSubstratePreparation(e.target.value) }
            // If vapor barrier has not yet been set, and 'moisture mitigation' and 'urethane cement' have not been selected, set this option as disabled.
            disabled={ (!stateVaporBarrier && systemTypeName.indexOf('moisture')===-1 && systemTypeName.indexOf('vapor')===-1 && systemTypeName.indexOf('urethane')===-1) ? true : false }
         >
         {   
            // If vapor barrier has not yet been set, and 'moisture mitigation' and 'urethane cement' have not selected, render "Select vapor barrier first". Else render "Select".
            (!stateVaporBarrier && systemTypeName.indexOf('moisture')===-1 && systemTypeName.indexOf('vapor')===-1 && systemTypeName.indexOf('urethane')===-1) ? (
               <option value="">Select vapor barrier first</option>
            ) : (
               <option value="Select">Select</option>
            )
         }
            {/* <option key={ 'None' } value={ 'None' }>None</option> */}
         {
            // Create an option for each available substrate preparation.
            substratePreparationsAvailable.map(spa => {
               return (
                  <option key={ spa } value={ spa }>{ spa }</option>
               )
            })
         }
         </CustomSelect>
         <CustomSelect
            label="Preferred Packaging Size*"
            name="preferredPackagingSize"
            onChange={ (e) => handlePreferredPackagingSizeChange(e.target.value) }
         >
            <option key={ 'Select' } value={ 'Select' }>Select</option>
            <option value="Small">Small</option>
            <option value="Large">Large</option>
         </CustomSelect>
           {
               (availableSmallChipColors.length > 0 || availableLargeChipColors.length > 0) &&
            <CustomChipAndColorFields
               // If system type is "Quartz", label input field as "quartz" instead of "chip"
                   label={"Chip Selection"}
               name="chipSelection"
               id="chipSelection"
               // If system type is "Quartz", send input field "quartz" instead of "chip"
                   colorType="chip" 
               image={ chipImage }
               disabled={ !statePreferredPackagingSize ? true : false } // If preferred packaging size has not yet been set, set this option as not available to select value yet.
            />
           }
           {
               (availableSmallQuartzColors.length > 0 || availableLargeQuartzColors.length > 0) &&
               <CustomChipAndColorFields
                   // If system type is "Quartz", label input field as "quartz" instead of "chip"
                   label={"Quartz Selection"}
                   name="chipSelection"
                   id="chipSelection"
                   // If system type is "Quartz", send input field "quartz" instead of "chip"
                   colorType="quartz"
                   image={chipImage}
                   disabled={!statePreferredPackagingSize ? true : false} // If preferred packaging size has not yet been set, set this option as not available to select value yet.
               />
           }
           {
               (availableSmallColors.length > 0 || availableLargeColors.length > 0) &&
               <CustomChipAndColorFields
                   label="Color Selection"
                   name="colorSelection"
                   id="colorSelection"
                   colorType="color"
                   image={colorImage}
                   disabled={!statePreferredPackagingSize ? true : false} // If preferred packaging size has not yet been set, set this option as not available to select value yet.
               />
           }
         {  
         // If 'moisture mitigation', don't include extra top coat, clinical plus, or traction additive fields.
         (systemTypeName.indexOf('moisture')===-1 && systemTypeName.indexOf('vapor')===-1) && (
         <React.Fragment>
            { 
               stateClinicalPlus===true ? (
                               <CustomToggle name="extraTopCoat" message="Extra Top Coat cannot be combined with Clinical Plus at this time." disabled>{topCoatLabel}</CustomToggle>
               ) : (
                                   <CustomToggle name="extraTopCoat" onChange={() => handleExtraTopCoatChange()}>{topCoatLabel}</CustomToggle>
               )
            }
            { 
               stateExtraTopCoat===true ? (
                  <CustomToggle name="clinicalPlus" message="Clinical Plus cannot be combined with Extra Top Coat at this time." disabled>Clinical Plus?</CustomToggle>
               ) : (
                  <CustomToggle name="clinicalPlus" onChange={ () => handleClinicalPlusChange() }>Clinical Plus?</CustomToggle>
               )
            }
            <CustomSelect
               label="Traction Additive"
               name="tractionAdditive"
               onBlur={ (e) => setStateTractionAdditive(e.target.value) }
            >
               <option value=""></option>
               <option key="none" value="None">None</option>
               {
                  resinousTractionAdditives.map(rta => {
                     return(
                        <option key={ rta.name } value={ rta.name }>{ rta.name }</option>
                     )
                  })
               }
            </CustomSelect>
         </React.Fragment>
         )}
         <button className="btn btn-primary" type="submit">{ isSubmitting ? 'Loading...' : 'Submit' }</button>
      </Form>
   )

   return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
            <h3>Provide Coverage Details</h3>
            <Formik
               initialValues={{
                  totalArea: stateTotalArea || '',
                  unit: 'sqft',
                  vaporBarrier: stateVaporBarrier || '',
                  substratePreparation: stateSubstratePreparation || '',
                       chipSelection: stateChipValue || '',
                  colorSelection: stateColorValue || '',
                  extraTopCoat: stateExtraTopCoat || '',
                  clinicalPlus: stateClinicalPlus || '',
                  tractionAdditive: stateTractionAdditive || '',
                  preferredPackagingSize: statePreferredPackagingSize || ''
               }}
               enableReinitialize
               validateOnChange={false}
               validateOnBlur={false}
               validationSchema={ validationSchemaBasedOnSystemType }
               onSubmit={ (values) => handleFormSubmission(values) }
            >
            { props => formProps(props.isSubmitting) }
            </Formik>
         </div>
           <AppNavigation />
         <ResinousCoverageDetailsModals
            availableColors={ availableColors }
               availableChipColors={availableChipColors}
               availableQuartzColors={availableQuartzColors}
            setChipValue={ setChipValue }
            setColorValue={ setColorValue }
            setStateChipValue={ setStateChipValue }
               setStateColorValue={setStateColorValue}
               setColorSku={setColorSku}
               setColorChipSku={setColorChipSku}
               setColorCoverage={setColorCoverage}
               setColorChipCoverage={setColorChipCoverage}
               setColorChipUnitsRequired={setColorChipUnitsRequired}
            setColorImage={ setColorImage }
            setChipImage={ setChipImage }
            systemTypeName={ systemTypeName }
         />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousCoverageDetails.js